import { CustomState } from "@hardware/Store/Reducers";
import setFieldValue from "@hardware/Store/State/Survey/SetFieldValue";
import { SurveyFormContext } from "@hardware/Widgets/Survey/SurveyForm";
import siteMessage from "@insite/client-framework/SiteMessage";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    label = "label",
    hintText = "hintText",
    isRequired = "isRequired",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.label]: string;
        [fields.hintText]: string;
        [fields.isRequired]: boolean;
    };
}

const mapStateToProps = (state: CustomState) => ({
    title: state.surveyForm.fieldValues["title"],
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface TitleStyles {
    titleTextField?: TextFieldPresentationProps;
}

export const titleStyles: TitleStyles = {};

const styles = titleStyles;

const Title: React.FC<Props> = ({ fields, title, setFieldValue }) => {
    const { label, hintText, isRequired } = fields;
    const surveyFormContext = React.useContext(SurveyFormContext);
    const [titleErrorMessage, setTitleErrorMessage] = React.useState("");

    React.useEffect(() => {
        surveyFormContext.validators.title = validateTitle;
        if (typeof title !== "undefined") {
            validateTitle();
        }
    }, [title]);

    React.useEffect(() => {
        surveyFormContext.validators.title = validateTitle;
    }, [isRequired]);

    const validateTitle = () => {
        const errorMessage = isRequired && !title ? (siteMessage("Field_Required", label) as string) : "";
        setTitleErrorMessage(errorMessage);
        return !errorMessage;
    };

    const titleChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFieldValue({ key: "title", value: event.target.value });
    };

    return (
        <TextField
            {...styles.titleTextField}
            label={label}
            required={isRequired}
            placeholder={hintText}
            value={title || ""}
            error={titleErrorMessage}
            onChange={titleChangeHandler}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(Title),
    definition: {
        group: "Survey" as any,
        icon: "input-pipe",
        fieldDefinitions: [
            {
                name: fields.label,
                displayName: "Label",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Title",
                isRequired: true,
            },
            {
                name: fields.hintText,
                displayName: "Hint Text",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Enter Title",
                isRequired: true,
            },
            {
                name: fields.isRequired,
                displayName: "Required Field",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
